// useIsDesktop — true on wide (desktop/laptop) viewports. Drives the web-only
// desktop shell (side nav + centred column). Phones never match the breakpoint,
// so the native app is unaffected.
import { useEffect, useState } from 'react';

export function useIsDesktop(min = 1024): boolean {
  const query = `(min-width: ${min}px)`;
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = () => setIsDesktop(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);
  return isDesktop;
}
